"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6677],{

/***/ 36677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2185);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_shared_modal_customPopup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78773);
/* harmony import */ var localization_i8intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54269);
/* harmony import */ var api_googletab__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37643);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_share__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21818);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30767);
/* harmony import */ var api_cleverTap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81511);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);
// import { Carousel } from "react-bootstrap";
// import Link from "next/link";
//import OptionDropdown from "components/category/about/optionDropdown/optionDropdown";
 // import { postLike } from "redux/actions/postAction";

 // import { useAmp } from "next/amp";

 // import { useSession } from "next-auth/react";
// import Image from "next/image";




 // import uiHelper from "utils/uiHelper";
// import { saveBookmark } from "redux/actions/bookmarksActions";

 // import { timeSince } from "constants/cardsConstant";
// import ClevertapReact from "utils/clevertapHelper";

 // import Image from "next/image";




var NewsImageTextBanner1 = function NewsImageTextBanner1(_ref) {
  var _postData$categorySlu, _postData$liveBlogDat, _postData$category, _postData$title, _postData$category2, _postData$title2, _postData$category3, _postData$title3;

  var postData = _ref.postData,
      hTag = _ref.hTag;
  console.log("NewsImageTextBanner1", postData); //const sessionData = JSON.parse(localStorage.getItem("lallantopSession2"));

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
  var query = router.query; // const { data: session } = useSession();
  // const { userLocalDetail } = useSelector(({ AuthReducer }) => AuthReducer);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      loginPrompt = _useState[0],
      setLoginPrompt = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0),
      videoDuration = _useState2[0],
      setVideoDuration = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(postData),
      postStateData = _useState3[0],
      setPostStateData = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      openShareModal = _useState4[0],
      setOpenShareModal = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}),
      shareData = _useState5[0],
      setShareData = _useState5[1];

  var _useSelector = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function (_ref2) {
    var PostReducer = _ref2.PostReducer;
    return PostReducer;
  }),
      postDetails = _useSelector.postDetails;

  var isHomePath = router.asPath === "/";
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      firstScroll = _useState6[0],
      setFirstScroll = _useState6[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (firstScroll === false) {
      var handleScroll = function handleScroll() {
        setFirstScroll(true);
        window.removeEventListener("scroll", handleScroll);
      };

      window.addEventListener("scroll", handleScroll);
    }
  }, [firstScroll]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var timer = setTimeout(function () {
      setFirstScroll(true);
    }, 10000);
    return function () {
      clearTimeout(timer);
    };
  }, []); // const countFormat = (count) => {
  //   return count > 1000 ? (count / 1000).toFixed(1).concat("k") : count;
  // };
  // const handleLike = (_id, postDetails) => {
  //   if (userLocalDetail?.id || session?.user?.email) {
  //     const { seriesId } = postStateData;
  //     dispatch(postLike({ _id, seriesId }, null, postDetails));
  //   } else {
  //     setLoginPrompt(true);
  //   }
  // };

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      language = _useState7[0],
      setLanguage = _useState7[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    setLanguage((0,localization_i8intl__WEBPACK_IMPORTED_MODULE_3__/* .getLanguage */ .G3)());
  }, []);
  var pageToOpen = "/".concat((postData === null || postData === void 0 ? void 0 : (_postData$categorySlu = postData.categorySlug) === null || _postData$categorySlu === void 0 ? void 0 : _postData$categorySlu.toLowerCase()) || (query === null || query === void 0 ? void 0 : query.categoryName), "/").concat((postData === null || postData === void 0 ? void 0 : postData.type) === "video" ? "video" : "post", "/").concat((postData === null || postData === void 0 ? void 0 : postData.postSlug) || ""); // const shareUrl = `${pageToOpen}?postId=${postStateData?._id}`;

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if ((postDetails === null || postDetails === void 0 ? void 0 : postDetails._id) === (postData === null || postData === void 0 ? void 0 : postData._id)) {
      setPostStateData(postDetails);
    }
  }, [postDetails, postData === null || postData === void 0 ? void 0 : postData._id]); // useEffect(() => {
  //   var au = document?.createElement("audio");
  //   au.src = postStateData?.assetFileLink;
  //   function handler() {
  //     var duration = au?.duration;
  //     setVideoDuration(new Date(duration * 1000).toISOString().substr(14, 5));
  //   }
  //   au.addEventListener("loadedmetadata", handler);
  //   return () => {
  //     au.removeEventListener("loadedmetadata", handler);
  //   };
  // }, [postStateData]);
  // const handleShare = () => {
  //   const share = {
  //     title: postData?.title,
  //     text: postData?.title,
  //   };
  //   //if (shareUrl) share.url = shareUrl;
  //   share.url = postData?.permalink;
  //   //console.log("share: ", share);
  //   setShareData(share);
  //   if (!navigator || !navigator.share) {
  //     setOpenShareModal(true);
  //     console.log("Platform not supported!");
  //   } else {
  //     uiHelper.share(share);
  //   }
  // };
  // const handleBookmark = (_id, type) => {
  //   if (userLocalDetail?.id || session?.user?.email) {
  //     const postObj = {
  //       table: "post",
  //       postId: _id,
  //       type: type,
  //     };
  //     dispatch(saveBookmark(postObj));
  //     //setShowDropdown((e) => !e);
  //   } else {
  //     if (setLoginPrompt) setLoginPrompt(true);
  //   }
  // };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
    className: "headline-box1",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: "headline-left-col",
      style: {
        position: "relative"
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
        className: "headline-pic-box",
        children: [(postData === null || postData === void 0 ? void 0 : postData.type) === "liveblog" && (postData === null || postData === void 0 ? void 0 : (_postData$liveBlogDat = postData.liveBlogData) === null || _postData$liveBlogDat === void 0 ? void 0 : _postData$liveBlogDat.eventStatus) === "live" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("img", {
          src: "/assets/images/giphy.gif",
          style: {
            position: "absolute",
            width: "80px",
            zIndex: "99",
            height: "80px",
            right: "0",
            top: "-10px"
          },
          alt: "live"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("a", {
          href: "".concat((postData === null || postData === void 0 ? void 0 : postData.eventStatus) === undefined ? pageToOpen : "/business/post/".concat(postData === null || postData === void 0 ? void 0 : postData.sefUrl) // query: {
          //   categoryName: postStateData?.name,
          //   postSlug: postStateData?.postSlug,
          //    categorySlug: postStateData?.categorySlug,
          // },
          ),
          passHref: true,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(api_cleverTap__WEBPACK_IMPORTED_MODULE_6__/* .MyLink */ .Md, {
            className: "headline-thumb",
            onCustomClick: function onCustomClick() {
              console.log(isHomePath, "home path");

              if (isHomePath) {
                (0,api_googletab__WEBPACK_IMPORTED_MODULE_4__/* .pushGoogleTabEvent */ .I)("lt_cards", (0,api_googletab__WEBPACK_IMPORTED_MODULE_4__/* .createHomeArticlePayload */ .s)(postData, {
                  Section: "Home"
                })); // ClevertapReact.event(
                //   "homepage_card",
                //   createHomeCardPayload("homepage_card", postStateData)
                // );
              } else if (router.asPath === "/video") {
                console.log("bdeio");
                (0,api_googletab__WEBPACK_IMPORTED_MODULE_4__/* .pushGoogleTabEvent */ .I)("lt_cards", (0,api_googletab__WEBPACK_IMPORTED_MODULE_4__/* .createHomeArticlePayload */ .s)(postData, {
                  Section: "Video"
                }));
              }
            },
            children: [(postData === null || postData === void 0 ? void 0 : postData.headingImageUrl) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("img", {
              src: firstScroll ? (postData === null || postData === void 0 ? void 0 : postData.headingImageUrl) + "?width=600" : (postData === null || postData === void 0 ? void 0 : postData.headingImageUrl) + "?width=150" // layout="fill"
              //     sizes="(max-width: 1500px) 100vw,
              //  (max-width: 768px) 70vw,
              //  (max-width: 500px) 40vw
              // "
              ,
              alt: (postData === null || postData === void 0 ? void 0 : postData.imgAltText) || "News pic"
            }), (postData === null || postData === void 0 ? void 0 : postData.thumbnail) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("img", {
              src: firstScroll ? (postData === null || postData === void 0 ? void 0 : postData.thumbnail) + "?width=600" : (postData === null || postData === void 0 ? void 0 : postData.thumbnail) + "?width=150" // layout="fill"
              //     sizes="(max-width: 1500px) 100vw,
              //  (max-width: 768px) 70vw,
              //  (max-width: 500px) 40vw
              // "
              ,
              alt: (postData === null || postData === void 0 ? void 0 : postData.imgAltText) || "News pic"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
              className: "news-type-box",
              children: [!(postData !== null && postData !== void 0 && postData.eventStatus) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("i", {
                className: "icon-".concat((postData === null || postData === void 0 ? void 0 : postData.type) === "text" || (postData === null || postData === void 0 ? void 0 : postData.type) === "liveblog" ? "cat-read" : (postData === null || postData === void 0 ? void 0 : postData.type) === "audio" ? "mic" : "play-circle")
              }), (postData === null || postData === void 0 ? void 0 : postData.type) === "audio" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
                children: videoDuration
              })]
            })]
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: "headline-right-col",
        style: {
          position: "relative"
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
          className: "headline-body",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
            className: "headline-info",
            style: {
              paddingTop: "0.5rem",
              height: "6rem"
            },
            children: hTag === 1 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("h1", {
              style: {
                marginBottom: "0rem",
                cursor: "pointer"
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("a", {
                rel: "preload",
                href: (postData === null || postData === void 0 ? void 0 : postData.eventStatus) === undefined ? pageToOpen : "/".concat(postData === null || postData === void 0 ? void 0 : (_postData$category = postData.category) === null || _postData$category === void 0 ? void 0 : _postData$category.sefUrl, "/post/").concat(postData === null || postData === void 0 ? void 0 : postData.sefUrl) // query: {
                //   categoryName: postStateData?.name,
                //   postSlug: postStateData?.postSlug,
                // },
                ,
                passHref: true,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("a", {
                  rel: "preload",
                  style: {
                    fontFamily: "Mukta,system-ui, -apple-system, BlinkMacSystemFont",
                    fontStyle: "normal",
                    fontWeight: "550",
                    fontSize: "18px",
                    lineHeight: "135%",
                    color: "#000000"
                  } // onCustomClick={() => {
                  //   if (isHomePath) {
                  //     // ClevertapReact.event(
                  //     //   "homepage_card",
                  //     //   createHomeCardPayload(
                  //     //     "homepage_card",
                  //     //     postStateData
                  //     //   )
                  //     // );
                  //   }
                  // }}
                  ,
                  children: postData === null || postData === void 0 ? void 0 : (_postData$title = postData.title) === null || _postData$title === void 0 ? void 0 : _postData$title.padEnd(88)
                })
              })
            }) : hTag === 2 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("h2", {
              style: {
                marginBottom: "0rem",
                cursor: "pointer"
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("a", {
                href: "".concat((postData === null || postData === void 0 ? void 0 : postData.eventStatus) === undefined ? pageToOpen : "/".concat(postData === null || postData === void 0 ? void 0 : (_postData$category2 = postData.category) === null || _postData$category2 === void 0 ? void 0 : _postData$category2.sefUrl, "/post/").concat(postData === null || postData === void 0 ? void 0 : postData.sefUrl) // query: {
                //   categoryName: postStateData?.name,
                //   postSlug: postStateData?.postSlug,
                // },
                ),
                passHref: true,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(api_cleverTap__WEBPACK_IMPORTED_MODULE_6__/* .MyLink */ .Md, {
                    style: {
                      fontFamily: "Mukta,system-ui, -apple-system, BlinkMacSystemFont",
                      fontStyle: "normal",
                      fontWeight: "550",
                      fontSize: "18px",
                      lineHeight: "135%",
                      color: "#000000"
                    },
                    onCustomClick: function onCustomClick() {
                      if (isHomePath) {// ClevertapReact.event(
                        //   "homepage_card",
                        //   createHomeCardPayload(
                        //     "homepage_card",
                        //     postStateData
                        //   )
                        // );
                      }
                    },
                    children: postData === null || postData === void 0 ? void 0 : (_postData$title2 = postData.title) === null || _postData$title2 === void 0 ? void 0 : _postData$title2.padEnd(88)
                  })
                })
              })
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("h3", {
              style: {
                marginBottom: "0rem",
                cursor: "pointer"
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("a", {
                href: "".concat((postData === null || postData === void 0 ? void 0 : postData.eventStatus) === undefined ? pageToOpen : "/".concat(postData === null || postData === void 0 ? void 0 : (_postData$category3 = postData.category) === null || _postData$category3 === void 0 ? void 0 : _postData$category3.sefUrl, "/post/").concat(postData === null || postData === void 0 ? void 0 : postData.sefUrl) // query: {
                //   categoryName: postStateData?.name,
                //   postSlug: postStateData?.postSlug,
                // },
                ),
                passHref: true,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("a", {
                  style: {
                    fontFamily: "Mukta,system-ui, -apple-system, BlinkMacSystemFont",
                    fontStyle: "normal",
                    fontWeight: "550",
                    fontSize: "18px",
                    lineHeight: "135%",
                    color: "#000000"
                  } // onCustomClick={() => {
                  //   if (isHomePath) {
                  //     // ClevertapReact.event(
                  //     //   "homepage_card",
                  //     //   createHomeCardPayload(
                  //     //     "homepage_card",
                  //     //     postStateData
                  //     //   )
                  //     // );
                  //   }
                  // }}
                  ,
                  children: postData === null || postData === void 0 ? void 0 : (_postData$title3 = postData.title) === null || _postData$title3 === void 0 ? void 0 : _postData$title3.padEnd(88)
                })
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
            className: "line-newsImageTextBanner1",
            style: {
              height: "1px",
              background: "rgba(166, 166, 166, 0.2)",
              width: "100%"
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {})]
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_shared_modal_customPopup__WEBPACK_IMPORTED_MODULE_2__["default"], {
      showModal: loginPrompt,
      onClose: function onClose() {
        return setLoginPrompt(false);
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      show: openShareModal,
      fullscreen: false,
      centered: true,
      size: "sm",
      onHide: function onHide() {
        return setOpenShareModal(false);
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
        className: "row p-2",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          className: "col-6",
          children: "Social Share"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          className: "col-6 text-end",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
            role: "button",
            onClick: function onClick() {
              return setOpenShareModal(false);
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
              className: "icon-close"
            })
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Body */ .Z.Body, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
          align: "center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_9__.FacebookShareButton, {
            quote: shareData.text,
            url: shareData.url,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_9__.FacebookIcon, {
              className: "me-1",
              size: 32,
              round: true
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_9__.TwitterShareButton, {
            title: shareData.text,
            url: shareData.url,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_9__.TwitterIcon, {
              className: "me-1",
              size: 32,
              round: true
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_9__.EmailShareButton, {
            url: shareData.url,
            subject: shareData.text,
            body: shareData.url,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_9__.EmailIcon, {
              className: "me-1",
              size: 32,
              round: true
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_9__.LinkedinShareButton, {
            title: shareData.text,
            url: shareData.url,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_9__.LinkedinIcon, {
              className: "me-1",
              size: 32,
              round: true
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_9__.WhatsappShareButton, {
            url: shareData.url,
            title: shareData.text,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_9__.WhatsappIcon, {
              className: "me-1",
              size: 32,
              round: true
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("hr", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("span", {
            style: {
              fontSize: "13px"
            },
            className: "text-dark",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
              id: "cpy",
              children: "Copy"
            }), " to Clipboard", " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("i", {
              className: "las la-clipboard la-lg"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("input", {
            style: {
              fontSize: "13px"
            },
            onClick: function onClick() {
              var et = document.getElementById("copy");
              et.select();
              document.execCommand("copy");
              document.getElementById("cpy").textContent = "Copied";
            },
            id: "copy",
            value: shareData.url,
            type: "text",
            readOnly: true,
            className: "form-control"
          })]
        })
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (NewsImageTextBanner1);

/***/ })

}]);